import React from 'react'
import ForecastingReport from '../features/Reports/forecasting-report/forecasting-report'

const Forcasting_Reports = () => {
  return (
    <div>
      <ForecastingReport/>
    </div>
  )
}

export default Forcasting_Reports
